import { render, staticRenderFns } from "./tpl_add.vue?vue&type=template&id=3fbf48dc&"
import script from "./tpl_add.vue?vue&type=script&lang=ts&"
export * from "./tpl_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports